import {
  createVPhoneInput,
  autocompletePhoneCountryInput,
  VPhoneCountryFlagSvg,
} from 'v-phone-input';
import 'v-phone-input/styles';
import 'flag-icons/css/flag-icons.min.css';

const vPhoneInput = createVPhoneInput({
  ...autocompletePhoneCountryInput,
  countryDisplayComponent: VPhoneCountryFlagSvg,
});

export default vPhoneInput;
